































































import { Component, Prop, Vue } from "vue-property-decorator";
import LabelPickup from "./LabelPickup.vue";
import Observer from "./Observer.vue";
import { mapState, mapGetters } from "vuex";

@Component({
	computed: {
		...mapState("pickup", ["eforms"]),
		...mapGetters({
			isLoadingComplete: "pickup/isLoadingComplete"
		})
	},
	components: {
		LabelPickup,
		Observer
	}
})
export default class TablePickup extends Vue {
	@Prop(Object) filterOptions: any;
	@Prop(Boolean) activeDetail: boolean;

	isLoadingComplete: boolean;
	selectedItem: string = "";
	actionDocumentsApprove: number = 78;
	actionCertificates: number = 205;

	selectEform(eform) {
		this.$store.dispatch("pickup/setEformSelected", eform);
		this.selectedItem = eform.id;
		this.$emit("showDetail", true);
	}

	created() {
		const filterOpts = { ...this.filterOptions };

		this.$store.dispatch("pickup/setInitialEforms", filterOpts).then().catch(error => {
			this.$emit('eformLock', error.response.data)
		});

		this.$store.dispatch("pickup/setEformTemplates");

		const { page } = this.filterOptions;

		this.filterOptions.page = page + 1;
	}

	intersected() {
		if (!this.isLoadingComplete) {
			const filterOpts = { ...this.filterOptions };

			this.$store.dispatch("pickup/addAditionalEforms", filterOpts);

			const { page } = this.filterOptions;

			this.filterOptions.page = page + 1;
		}
	}

	get pickupActionEnable() {
		return this.$store.getters['isActionAllowed'](this.actionDocumentsApprove)
	}

	get certificateActionEnable() {
		return this.$store.getters['isActionAllowed'](this.actionCertificates)
	}
}
